module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/BreakdownTable/styles.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default.a);
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".breakdown-table{line-height:24px}.breakdown-table__row{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:16px;width:auto}.breakdown-table__col-icon{width:30px}.breakdown-table__col-lg{flex:1}", "",{"version":3,"sources":["webpack://./src/components/BreakdownTable/styles.scss"],"names":[],"mappings":"AAAA,iBACI,gBAAA,CACA,sBACI,YAAA,CACA,kBAAA,CACA,6BAAA,CACA,kBAAA,CACA,UAAA,CAEJ,2BACI,UAAA,CAEJ,yBACG,MAAA","sourcesContent":[".breakdown-table {\r\n    line-height: 24px;\r\n    &__row {\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: space-between;\r\n        margin-bottom: 16px;\r\n        width: auto;\r\n    }\r\n    &__col-icon {\r\n        width: 30px;\r\n    }\r\n    &__col-lg {\r\n       flex: 1;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ __webpack_exports__["a"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/InfoCard/styles.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default.a);
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".info-card{background:#fff;border-radius:6px;border:1px solid;display:flex;flex-direction:column;margin:auto;margin-bottom:28px;padding:24px 16px;position:relative}@media screen and (min-width: 768px){.info-card{padding:24px 24px 18px}}.info-card:first-child{margin-top:12px}.info-card__title{font-size:18px;font-weight:bold;line-height:26px;text-transform:unset;margin:14px 0 8px}.info-card__description{color:#757989;font-size:16px;line-height:24px}.info-card__line-item{display:flex;font-size:16px;justify-content:space-between;line-height:24px}.info-card__line-item.dark{color:#fff}.info-card__line-item.strong{font-weight:bold}", "",{"version":3,"sources":["webpack://./src/components/InfoCard/styles.scss"],"names":[],"mappings":"AAAA,WACI,eAAA,CACA,iBAAA,CACA,gBAAA,CACA,YAAA,CACA,qBAAA,CACA,WAAA,CACA,kBAAA,CACA,iBAAA,CACA,iBAAA,CAEA,qCAXJ,WAYQ,sBAAA,CAAA,CAEJ,uBACE,eAAA,CAEF,kBACI,cAAA,CACA,gBAAA,CACA,gBAAA,CACA,oBAAA,CACA,iBAAA,CAEJ,wBACI,aAAA,CACA,cAAA,CACA,gBAAA,CAEJ,sBACI,YAAA,CACA,cAAA,CACA,6BAAA,CACA,gBAAA,CAEA,2BACI,UAAA,CAGJ,6BACI,gBAAA","sourcesContent":[".info-card {\r\n    background: #fff;\r\n    border-radius: 6px;\r\n    border: 1px solid;\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: auto;\r\n    margin-bottom: 28px;\r\n    padding: 24px 16px;\r\n    position: relative;\r\n  \r\n    @media screen and (min-width: 768px) {\r\n        padding: 24px 24px 18px;\r\n    }\r\n    &:first-child {\r\n      margin-top: 12px;\r\n    }\r\n    &__title {\r\n        font-size: 18px;\r\n        font-weight: bold;\r\n        line-height: 26px;\r\n        text-transform: unset;\r\n        margin: 14px 0 8px;\r\n    }\r\n    &__description {\r\n        color: #757989;\r\n        font-size: 16px;\r\n        line-height: 24px;\r\n    }\r\n    &__line-item {\r\n        display: flex;\r\n        font-size: 16px;\r\n        justify-content: space-between;\r\n        line-height: 24px;\r\n\r\n        &.dark {\r\n            color: #fff;\r\n          }\r\n        \r\n        &.strong {\r\n            font-weight: bold;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ __webpack_exports__["a"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/SavingsTag/styles.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default.a);
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".savings-tag{display:flex}.savings-tag__content{position:relative;border-radius:6px;overflow:hidden;display:flex;align-items:center;width:auto;min-height:24px;padding:0 5px 0 28px;font-size:12px;box-sizing:border-box}.savings-tag__icon-wrapper{width:24px;height:24px;left:0;position:absolute;display:flex;align-items:center;justify-content:center}.savings-tag__icon-wrapper svg{fill:#fff}", "",{"version":3,"sources":["webpack://./src/components/SavingsTag/styles.scss"],"names":[],"mappings":"AAAA,aACI,YAAA,CAEA,sBACI,iBAAA,CACA,iBAAA,CACA,eAAA,CACA,YAAA,CACA,kBAAA,CACA,UAAA,CACA,eAAA,CACA,oBAAA,CACA,cAAA,CACA,qBAAA,CAGJ,2BACI,UAAA,CACA,WAAA,CACA,MAAA,CACA,iBAAA,CACA,YAAA,CACA,kBAAA,CACA,sBAAA,CAEA,+BACI,SAAA","sourcesContent":[".savings-tag {\r\n    display: flex;\r\n\r\n    &__content {\r\n        position: relative;\r\n        border-radius: 6px;\r\n        overflow: hidden;\r\n        display: flex;\r\n        align-items: center;\r\n        width: auto;\r\n        min-height: 24px;\r\n        padding: 0 5px 0 28px;\r\n        font-size: 12px;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &__icon-wrapper {\r\n        width: 24px;\r\n        height: 24px;\r\n        left: 0;\r\n        position: absolute;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        svg {\r\n            fill: #fff;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ __webpack_exports__["a"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/WSYSCallOut/styles.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default.a);
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".incentive-callout{font-weight:bold;margin-top:28px;padding:8px 20px;border-radius:3px;text-align:center}.incentive-callout p{width:70%;margin:0 auto}", "",{"version":3,"sources":["webpack://./src/components/WSYSCallOut/styles.scss"],"names":[],"mappings":"AAAA,mBACI,gBAAA,CACA,eAAA,CACA,gBAAA,CACA,iBAAA,CACA,iBAAA,CACA,qBACI,SAAA,CACA,aAAA","sourcesContent":[".incentive-callout {\r\n    font-weight: bold;\r\n    margin-top: 28px;\r\n    padding: 8px 20px;\r\n    border-radius: 3px;\r\n    text-align: center;\r\n    p {\r\n        width: 70%;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ __webpack_exports__["a"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/styles.scss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default.a);
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".trade-in-details{font-family:\"Brandon Text\";padding-bottom:40px}.trade-in-details p{margin:0}.trade-in-details .bold{font-weight:bold}.trade-in-details__hero{margin-bottom:-48px;padding-bottom:56px;padding-top:32px}.trade-in-details__header-text{font-size:24px;font-weight:600;line-height:30px;margin-bottom:20px;text-transform:unset}.trade-in-details__content{display:flex;flex-direction:column;margin:auto;max-width:526px;padding:0 24px}.trade-in-details__line-item{display:flex;font-size:16px;justify-content:space-between;line-height:24px}.trade-in-details__line-item.dark{color:#fff}.trade-in-details__line-item.strong{font-weight:bold}.trade-in-details .horizontal-rule{border:none;border-bottom:1px solid #d9dde9;margin:16px 0;width:100%}", "",{"version":3,"sources":["webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,kBACI,0BAAA,CACA,mBAAA,CAEA,oBACE,QAAA,CAEF,wBACI,gBAAA,CAEJ,wBACI,mBAAA,CACA,mBAAA,CACA,gBAAA,CAEJ,+BACI,cAAA,CACA,eAAA,CACA,gBAAA,CACA,kBAAA,CACA,oBAAA,CAEJ,2BACI,YAAA,CACA,qBAAA,CACA,WAAA,CACA,eAAA,CACA,cAAA,CAEJ,6BACI,YAAA,CACA,cAAA,CACA,6BAAA,CACA,gBAAA,CAEA,kCACI,UAAA,CAGJ,oCACI,gBAAA,CAGR,mCACI,WAAA,CACA,+BAAA,CACA,aAAA,CACA,UAAA","sourcesContent":[".trade-in-details {\r\n    font-family: 'Brandon Text';\r\n    padding-bottom: 40px;\r\n\r\n    p {\r\n      margin: 0;\r\n    }\r\n    .bold {\r\n        font-weight: bold;\r\n    }\r\n    &__hero {\r\n        margin-bottom: -48px;\r\n        padding-bottom: 56px;\r\n        padding-top: 32px;\r\n    }\r\n    &__header-text {\r\n        font-size: 24px;\r\n        font-weight: 600;\r\n        line-height: 30px;\r\n        margin-bottom: 20px;\r\n        text-transform: unset;\r\n    }\r\n    &__content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin: auto;\r\n        max-width: calc(478px + 48px);\r\n        padding: 0 24px;\r\n    }\r\n    &__line-item {\r\n        display: flex;\r\n        font-size: 16px;\r\n        justify-content: space-between;\r\n        line-height: 24px;\r\n\r\n        &.dark {\r\n            color: #fff;\r\n          }\r\n        \r\n        &.strong {\r\n            font-weight: bold;\r\n        }\r\n    }\r\n    .horizontal-rule {\r\n        border: none;\r\n        border-bottom: 1px solid #d9dde9;\r\n        margin: 16px 0;\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ __webpack_exports__["a"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../../node_modules/css-loader/dist/runtime/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join("");
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === "string") {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, ""]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

module.exports = function cssWithMappingToString(item) {
  var _item = _slicedToArray(item, 4),
      content = _item[1],
      cssMapping = _item[3];

  if (typeof btoa === "function") {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || "").concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join("\n");
  }

  return [content].join("\n");
};

/***/ }),

/***/ "../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: D:/a/1/s/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__("../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);

// EXTERNAL MODULE: D:/a/1/s/node_modules/css-loader/dist/cjs.js!D:/a/1/s/node_modules/sass-loader/dist/cjs.js!./src/styles.scss
var styles = __webpack_require__("../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/styles.scss");

// CONCATENATED MODULE: ./src/styles.scss

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = injectStylesIntoStyleTag_default()(styles["a" /* default */], options);



/* harmony default export */ var src_styles = (styles["a" /* default */].locals || {});
// CONCATENATED MODULE: ./src/TradeInDetails.content.ts
const addedToDownPaymentLabel = 'Added to your down payment';
const addedToMonthlyPaymentsLabel = 'Added to monthly payments';
const appliedToDownPaymentLabel = 'Applied to your down payment';
const flexibilityToPayOffHeader = 'Flexibility to help payoff your loan balance.';
const incentivePurchasePriceSavingsLabel = 'Purchase price savings';
const learnMoreCta = 'Learn More';
const loanBalanceLabel = 'Loan balance';
const modalTitle = 'Trade In Details';
const rolloverText = 'Instead of paying the remaining balance of your loan out of pocket, we can help add up to $2,500 of your existing balance to the loan for your next car. This works a lot like refinancing. Get pre-qualified to see personalized financing terms while you shop.';
const rolloverTextWithDownPayment = 'Instead of paying the remaining balance of your loan out of pocket, we can help add up to $2,500 of your existing balance to the loan for your next car. The rest will be added to your down payment. This works a lot like refinancing. Get pre-qualified to see personalized financing terms while you shop.';
const salesTaxSavingsAmountText = 'Sales tax savings (estimate)';
const saveInSalesTaxHeader = (salesTaxSavingsAmountValue, taxState) => `Save ${salesTaxSavingsAmountValue} in ${taxState} sales tax, instantly.`;
const applyIncentiveHeader = incentive => `Get ${incentive} off the price of any Carvana Certified car`;
const saveMoreTag = 'Sales Tax Savings';
const sellOrTradeFooter = 'Sell or trade, we’ll be ready when you are. Save your offer to shop our 20,000 Carvana Certified vehicles with your trade-in applied.';
const tradeInSavingsTag = 'Trade-in savings';
const tradeInTaxSavingsDescription = 'When you trade in your old vehicle with the purchase of your next one, it reduces the sales tax you pay. This means a lower total purchase price and lower monthly payments. These savings are only available when you trade in.';
const incentiveDescription = 'Trade in your vehicle for more savings, simple online checkout, and one appointment to swap your old car for your new one.';
const yourTradeInDetailsTitle = 'Your trade in details';
const applyDefaultCardTitle = amount => `Apply ${amount} towards the down payment of your new vehicle`;
const defaultCardTradeInSavingsLabel = 'Total trade in savings';
const applyDefaultCardDescription = 'Reduce your monthly payments by applying your total trade in value towards your new vehicle.';
/* harmony default export */ var TradeInDetails_content = ({
  addedToDownPaymentLabel,
  addedToMonthlyPaymentsLabel,
  appliedToDownPaymentLabel,
  applyDefaultCardTitle,
  applyDefaultCardDescription,
  applyIncentiveHeader,
  defaultCardTradeInSavingsLabel,
  flexibilityToPayOffHeader,
  incentiveDescription,
  incentivePurchasePriceSavingsLabel,
  learnMoreCta,
  loanBalanceLabel,
  modalTitle,
  rolloverText,
  rolloverTextWithDownPayment,
  salesTaxSavingsAmountText,
  saveInSalesTaxHeader,
  saveMoreTag,
  sellOrTradeFooter,
  tradeInSavingsTag,
  tradeInTaxSavingsDescription,
  yourTradeInDetailsTitle
});
// CONCATENATED MODULE: ./src/utilities/currency.ts
const currency = function (value, addPlus, noIndicator) {
  if (addPlus === void 0) {
    addPlus = false;
  }
  if (noIndicator === void 0) {
    noIndicator = false;
  }
  if (!Number.isFinite(value)) {
    return '';
  }
  const positiveIndicator = addPlus ? '+ ' : '';
  const withIndicator = value < 0 ? '- ' : positiveIndicator;
  const indicator = noIndicator ? '' : withIndicator;
  return `${indicator}$${Math.round(Math.abs(value)).toLocaleString()}`;
};

// CONCATENATED MODULE: ./src/utilities/theme.ts
const defaultTheme = {
  heroBackgroundColor: '#00619e',
  heroTextColor: '#fff',
  displayTextColor: '#183558',
  borderColor: '#d9dde9',
  incentivePrimaryColor: '#2F9E44',
  incentiveSecondaryColor: '#ebfbee'
};

// CONCATENATED MODULE: ./src/icons/Calculation.tsx

const Calculation = () => /*#__PURE__*/external_react_default.a.createElement("svg", {
  width: "18",
  height: "23",
  viewBox: "0 0 18 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/external_react_default.a.createElement("path", {
  d: "M14.7091 18.0323C15.2514 18.0323 15.6647 18.0323 15.9794 18.0323C16.5316 18.0323 16.9671 17.5845 16.9671 17.0323V2C16.9671 1.44772 16.5194 1 15.9671 1H6.6123C6.06002 1 5.6123 1.44604 5.6123 1.99833C5.6123 3.28842 5.6123 5.64211 5.6123 7.93548",
  stroke: "#D9DDE9",
  strokeWidth: "2",
  strokeLinecap: "round"
}), /*#__PURE__*/external_react_default.a.createElement("rect", {
  x: "7.74121",
  y: "3.12891",
  width: "7.09677",
  height: "4.25806",
  fill: "#D9DDE9"
}), /*#__PURE__*/external_react_default.a.createElement("rect", {
  x: "13.4189",
  y: "11.6455",
  width: "1.41935",
  height: "4.25806",
  fill: "#D9DDE9"
}), /*#__PURE__*/external_react_default.a.createElement("rect", {
  x: "7.74121",
  y: "8.80664",
  width: "1.41935",
  height: "1.41935",
  fill: "#D9DDE9"
}), /*#__PURE__*/external_react_default.a.createElement("rect", {
  x: "10.5801",
  y: "8.80664",
  width: "1.41935",
  height: "1.41935",
  fill: "#D9DDE9"
}), /*#__PURE__*/external_react_default.a.createElement("rect", {
  x: "13.4189",
  y: "8.80664",
  width: "1.41935",
  height: "1.41935",
  fill: "#D9DDE9"
}), /*#__PURE__*/external_react_default.a.createElement("circle", {
  cx: "6",
  cy: "16.4238",
  r: "5",
  stroke: "#D9DDE9",
  strokeWidth: "2"
}), /*#__PURE__*/external_react_default.a.createElement("path", {
  d: "M7.4764 14.9902L4.6377 17.8289",
  stroke: "#D9DDE9",
  strokeWidth: "2",
  strokeLinecap: "round"
}), /*#__PURE__*/external_react_default.a.createElement("circle", {
  cx: "7.89551",
  cy: "18.335",
  r: "1",
  fill: "#D9DDE9"
}), /*#__PURE__*/external_react_default.a.createElement("circle", {
  cx: "4.10547",
  cy: "14.5117",
  r: "1",
  fill: "#D9DDE9"
}));
/* harmony default export */ var icons_Calculation = (Calculation);
// CONCATENATED MODULE: ./src/icons/MoneyRound.tsx

const MoneyRound = () => /*#__PURE__*/external_react_default.a.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/external_react_default.a.createElement("path", {
  d: "M12.039 1.88232L12.3496 2.04383L12.6931 1.97636L13.7363 1.77145L14.5032 2.50786L14.7557 2.75034L15.1043 2.78238L16.1631 2.87969L16.6914 3.80233L16.8653 4.10612L17.1908 4.23508L18.1792 4.62673L18.4262 5.66083L18.5076 6.00134L18.7835 6.21676L19.6216 6.87102L19.5672 7.93282L19.5493 8.28244L19.7534 8.56689L20.3732 9.43075L20.0219 10.4342L19.9062 10.7646L20.0219 11.0951L20.3732 12.0985L19.7534 12.9624L19.5493 13.2469L19.5672 13.5965L19.6216 14.6583L18.7835 15.3125L18.5076 15.528L18.4262 15.8685L18.1792 16.9026L17.1908 17.2942L16.8653 17.4232L16.6914 17.727L16.1631 18.6496L15.1043 18.7469L14.7557 18.779L14.5032 19.0214L13.7363 19.7578L12.6931 19.5529L12.3496 19.4855L12.039 19.647L11.0957 20.1375L10.1524 19.647L9.84184 19.4855L9.49832 19.5529L8.45506 19.7578L7.6882 19.0214L7.43569 18.779L7.08708 18.7469L6.02835 18.6496L5.50002 17.727L5.32606 17.4232L5.0006 17.2942L4.01216 16.9026L3.76517 15.8685L3.68385 15.528L3.4079 15.3125L2.56985 14.6583L2.6242 13.5965L2.6421 13.2469L2.43802 12.9624L1.81824 12.0985L2.16954 11.0951L2.28521 10.7646L2.16954 10.4342L1.81824 9.43075L2.43802 8.56689L2.6421 8.28244L2.6242 7.93282L2.56985 6.87102L3.4079 6.21676L3.68385 6.00134L3.76517 5.66083L4.01216 4.62673L5.0006 4.23508L5.32606 4.10612L5.50002 3.80233L6.02835 2.87969L7.08708 2.78238L7.43569 2.75034L7.6882 2.50786L8.45506 1.77145L9.49832 1.97636L9.84184 2.04383L10.1524 1.88232L11.0957 1.39178L12.039 1.88232Z",
  stroke: "#D9DDE9",
  strokeWidth: "2"
}), /*#__PURE__*/external_react_default.a.createElement("path", {
  d: "M10.7622 14.6225V15.8705C10.7622 16.0745 10.9902 16.0865 11.1342 16.0865C11.2662 16.0865 11.3742 16.0025 11.3742 15.8705V14.6225C12.9822 14.5265 13.8702 13.5665 13.8702 12.2585C13.8702 10.6865 12.4182 9.96653 11.3742 9.53453C11.3742 8.81453 11.3742 8.05853 11.3742 7.33853C11.9382 7.45853 12.4062 7.75853 12.7422 7.98653C12.8502 8.05853 12.9822 8.02253 13.0782 7.89053L13.5582 7.19453C13.6422 7.06253 13.6062 6.87053 13.4862 6.79853C13.2702 6.64253 12.4422 6.10253 11.3742 6.01853V5.62253C11.3742 5.49053 11.2662 5.39453 11.1462 5.39453H10.9902C10.8702 5.39453 10.7622 5.49053 10.7622 5.62253V6.00653C9.1182 6.13853 8.3862 7.14653 8.3862 8.28653C8.3862 9.87053 9.6462 10.5065 10.7622 10.9505V13.2905C10.2342 13.2065 9.7302 12.9425 9.3702 12.6425C9.1302 12.4385 8.9862 12.4625 8.8902 12.6185L8.4222 13.3385C8.3142 13.5185 8.3742 13.5905 8.4822 13.6985C8.6982 13.9025 9.4662 14.5265 10.7622 14.6225ZM10.7622 9.29453C10.1502 8.97053 9.8502 8.70653 9.8502 8.22653C9.8502 7.75853 10.1622 7.41053 10.7622 7.33853V9.29453ZM11.3742 13.3145V11.2025C12.0222 11.5385 12.2982 11.9585 12.2982 12.4265C12.2982 12.9665 11.9142 13.2545 11.3742 13.3145Z",
  fill: "#D9DDE9"
}));
/* harmony default export */ var icons_MoneyRound = (MoneyRound);
// CONCATENATED MODULE: ./src/components/BreakdownTable/Breakdown.content.ts
const amountYouOwe = 'Amount you owe';
const applyAsDownPaymentLabel = 'We’ll apply this amount as the down payment on your next car.';
const breakdownAmountLabel = 'Offer amount';
const paymentToYou = 'Payment to you';
const yourOfferLabel = 'Your Trade In Offer';

// EXTERNAL MODULE: D:/a/1/s/node_modules/css-loader/dist/cjs.js!D:/a/1/s/node_modules/sass-loader/dist/cjs.js!./src/components/BreakdownTable/styles.scss
var BreakdownTable_styles = __webpack_require__("../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/BreakdownTable/styles.scss");

// CONCATENATED MODULE: ./src/components/BreakdownTable/styles.scss

            

var styles_options = {};

styles_options.insert = "head";
styles_options.singleton = false;

var styles_update = injectStylesIntoStyleTag_default()(BreakdownTable_styles["a" /* default */], styles_options);



/* harmony default export */ var components_BreakdownTable_styles = (BreakdownTable_styles["a" /* default */].locals || {});
// CONCATENATED MODULE: ./src/components/BreakdownTable/BreakdownTable.tsx






const Table = _ref => {
  let {
    hasLien,
    lienAmount,
    lienItemLabel,
    positiveText = paymentToYou,
    value
  } = _ref;
  const lienAsNegative = lienAmount * -1;
  const totalValue = value + lienAsNegative;
  const valueAmount = currency(value, false);
  const totalCashValue = currency(totalValue, false, true);
  const lienAmountDisplay = currency(lienAsNegative, true);
  const hasNegativeEquity = totalValue < 0;
  const totalLabel = hasNegativeEquity ? amountYouOwe : positiveText;
  return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, hasLien ? /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "breakdown-table"
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "breakdown-table__row"
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "breakdown-table__col-icon"
  }, /*#__PURE__*/external_react_default.a.createElement(icons_MoneyRound, null)), /*#__PURE__*/external_react_default.a.createElement("p", {
    className: "breakdown-table__col-lg"
  }, breakdownAmountLabel), /*#__PURE__*/external_react_default.a.createElement("p", null, valueAmount)), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "breakdown-table__row"
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "breakdown-table__col-icon"
  }, /*#__PURE__*/external_react_default.a.createElement(icons_Calculation, null)), /*#__PURE__*/external_react_default.a.createElement("p", {
    className: "breakdown-table__col-lg"
  }, lienItemLabel), /*#__PURE__*/external_react_default.a.createElement("p", null, lienAmountDisplay)), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "horizontal-rule"
  }), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "breakdown-table__row"
  }, /*#__PURE__*/external_react_default.a.createElement("p", null, totalLabel), /*#__PURE__*/external_react_default.a.createElement("p", {
    className: "bold"
  }, totalCashValue))) : /*#__PURE__*/external_react_default.a.createElement("div", null, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "trade-in-details__line-item dark"
  }, applyAsDownPaymentLabel), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "horizontal-rule"
  }), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "trade-in-details__line-item dark"
  }, /*#__PURE__*/external_react_default.a.createElement("p", null, yourOfferLabel), /*#__PURE__*/external_react_default.a.createElement("p", {
    className: "bold"
  }, currency(value)))));
};
/* harmony default export */ var BreakdownTable = (Table);
// CONCATENATED MODULE: ./src/icons/Tag.tsx
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Tag = _ref => {
  let {
    height = 16,
    width = 16,
    ...props
  } = _ref;
  return /*#__PURE__*/external_react_default.a.createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "m1.077 10.606 4.387 4.387a1 1 0 0 0 1.415 0l6.85-6.85a.999.999 0 0 0 .225-.344l1.313-3.37a1 1 0 0 0-.224-1.071l-2.31-2.309A1 1 0 0 0 11.67.822L8.275 2.117a1 1 0 0 0-.35.227L1.077 9.19a1 1 0 0 0 0 1.415Zm8.87-4.482a1.75 1.75 0 1 0 2.474-2.475 1.75 1.75 0 0 0-2.475 2.475Z",
    fillRule: "evenodd"
  }));
};
/* harmony default export */ var icons_Tag = (Tag);
// EXTERNAL MODULE: D:/a/1/s/node_modules/css-loader/dist/cjs.js!D:/a/1/s/node_modules/sass-loader/dist/cjs.js!./src/components/SavingsTag/styles.scss
var SavingsTag_styles = __webpack_require__("../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/SavingsTag/styles.scss");

// CONCATENATED MODULE: ./src/components/SavingsTag/styles.scss

            

var SavingsTag_styles_options = {};

SavingsTag_styles_options.insert = "head";
SavingsTag_styles_options.singleton = false;

var SavingsTag_styles_update = injectStylesIntoStyleTag_default()(SavingsTag_styles["a" /* default */], SavingsTag_styles_options);



/* harmony default export */ var components_SavingsTag_styles = (SavingsTag_styles["a" /* default */].locals || {});
// CONCATENATED MODULE: ./src/components/SavingsTag/SavingsTag.tsx



const SavingsTag = _ref => {
  let {
    text,
    theme
  } = _ref;
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "savings-tag"
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "savings-tag__content",
    style: {
      backgroundColor: theme.incentiveSecondaryColor,
      color: theme.incentivePrimaryColor
    }
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "savings-tag__icon-wrapper",
    style: {
      backgroundColor: theme.incentivePrimaryColor
    }
  }, /*#__PURE__*/external_react_default.a.createElement(icons_Tag, null)), text));
};
/* harmony default export */ var SavingsTag_SavingsTag = (SavingsTag);
// EXTERNAL MODULE: D:/a/1/s/node_modules/css-loader/dist/cjs.js!D:/a/1/s/node_modules/sass-loader/dist/cjs.js!./src/components/InfoCard/styles.scss
var InfoCard_styles = __webpack_require__("../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/InfoCard/styles.scss");

// CONCATENATED MODULE: ./src/components/InfoCard/styles.scss

            

var InfoCard_styles_options = {};

InfoCard_styles_options.insert = "head";
InfoCard_styles_options.singleton = false;

var InfoCard_styles_update = injectStylesIntoStyleTag_default()(InfoCard_styles["a" /* default */], InfoCard_styles_options);



/* harmony default export */ var components_InfoCard_styles = (InfoCard_styles["a" /* default */].locals || {});
// CONCATENATED MODULE: ./src/components/InfoCard/InfoCard.tsx



const InfoCard = _ref => {
  let {
    name,
    savingsTagText,
    theme,
    title,
    description,
    lineItems
  } = _ref;
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: `info-card info-card__${name}`,
    style: {
      borderColor: theme.borderColor
    }
  }, savingsTagText && /*#__PURE__*/external_react_default.a.createElement(SavingsTag_SavingsTag, {
    text: savingsTagText,
    theme: theme
  }), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "info-card__title",
    style: {
      color: theme.displayTextColor
    }
  }, title), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "info-card__description"
  }, description), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "horizontal-rule",
    style: {
      borderColor: theme.borderColor
    }
  }), lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(item => /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "info-card__line-item",
    key: item,
    style: {
      color: theme.displayTextColor
    }
  }, /*#__PURE__*/external_react_default.a.createElement("p", null, item.title), /*#__PURE__*/external_react_default.a.createElement("p", {
    className: "bold"
  }, item.amount))));
};
/* harmony default export */ var InfoCard_InfoCard = (InfoCard);
// EXTERNAL MODULE: D:/a/1/s/node_modules/css-loader/dist/cjs.js!D:/a/1/s/node_modules/sass-loader/dist/cjs.js!./src/components/WSYSCallOut/styles.scss
var WSYSCallOut_styles = __webpack_require__("../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/components/WSYSCallOut/styles.scss");

// CONCATENATED MODULE: ./src/components/WSYSCallOut/styles.scss

            

var WSYSCallOut_styles_options = {};

WSYSCallOut_styles_options.insert = "head";
WSYSCallOut_styles_options.singleton = false;

var WSYSCallOut_styles_update = injectStylesIntoStyleTag_default()(WSYSCallOut_styles["a" /* default */], WSYSCallOut_styles_options);



/* harmony default export */ var components_WSYSCallOut_styles = (WSYSCallOut_styles["a" /* default */].locals || {});
// CONCATENATED MODULE: ./src/components/WSYSCallOut/WSYSCallOut.tsx


const WSYSCallOut = _ref => {
  let {
    incentiveAmount,
    salesTaxSavingsAmount,
    savings,
    theme
  } = _ref;
  const hasOnlySavings = incentiveAmount <= 0 && salesTaxSavingsAmount > 0;
  const hasOnlyIncentive = salesTaxSavingsAmount <= 0 && incentiveAmount > 0;
  const hasIncentiveAndSavings = salesTaxSavingsAmount > 0 && incentiveAmount > 0;
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "incentive-callout",
    style: {
      backgroundColor: theme.incentiveSecondaryColor,
      color: theme.incentivePrimaryColor
    }
  }, hasOnlySavings && /*#__PURE__*/external_react_default.a.createElement("p", null, `Get ${savings} more with your sales tax savings`), hasOnlyIncentive && /*#__PURE__*/external_react_default.a.createElement("p", null, `Get ${savings} more with your trade in savings`), hasIncentiveAndSavings && /*#__PURE__*/external_react_default.a.createElement("p", null, `Get ${savings} more with your trade in and sales tax savings`));
};
/* harmony default export */ var WSYSCallOut_WSYSCallOut = (WSYSCallOut);
// CONCATENATED MODULE: ./src/components/WSYSCallOut/index.ts

/* harmony default export */ var components_WSYSCallOut = (WSYSCallOut_WSYSCallOut);
// CONCATENATED MODULE: ./src/TradeInDetails.tsx








const TradeInDetails = _ref => {
  let {
    incentiveAmount,
    lienAmount,
    salesTaxSavingsAmount,
    taxState,
    theme = defaultTheme,
    value
  } = _ref;
  theme = {
    ...defaultTheme,
    ...theme
  };
  const equity = value - lienAmount;
  const hasNegativeEquity = equity < 0;
  const hasTaxSavings = taxState && salesTaxSavingsAmount >= 1;
  const hasLien = !!lienAmount;
  const hasIncentive = !!incentiveAmount;
  const excessiveNegativeEquityAmount = 2500;
  const extraMonthlyPayment = Math.min(Math.abs(equity), excessiveNegativeEquityAmount);
  const extraMonthlyPaymentDisplay = currency(extraMonthlyPayment);
  const extraDownPayment = Math.abs(equity) - extraMonthlyPayment;
  const extraDownPaymentDisplay = currency(extraDownPayment);
  const hasDownPaymentModifier = extraDownPayment > 0;
  const payoffText = hasDownPaymentModifier ? TradeInDetails_content.rolloverTextWithDownPayment : TradeInDetails_content.rolloverText;
  const totalSavings = salesTaxSavingsAmount + incentiveAmount;
  const negativeEquityLineItems = [{
    title: TradeInDetails_content.addedToMonthlyPaymentsLabel,
    amount: extraMonthlyPaymentDisplay
  }, ...(hasDownPaymentModifier ? [{
    title: TradeInDetails_content.addedToDownPaymentLabel,
    amount: extraDownPaymentDisplay
  }] : [])];
  const salesTaxSavingsAmountValue = currency(Math.floor(salesTaxSavingsAmount));
  const salesTaxLineItems = [{
    title: TradeInDetails_content.salesTaxSavingsAmountText,
    amount: salesTaxSavingsAmountValue
  }];
  const incentiveAmountValue = currency(incentiveAmount);
  const incentiveLineItems = [{
    title: TradeInDetails_content.incentivePurchasePriceSavingsLabel,
    amount: incentiveAmountValue
  }];
  const applyToDownPaymentAmount = value - lienAmount;
  const defaultCardLineItems = [{
    title: TradeInDetails_content.defaultCardTradeInSavingsLabel,
    amount: currency(applyToDownPaymentAmount)
  }];
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "trade-in-details"
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "trade-in-details__hero",
    style: {
      backgroundColor: theme.heroBackgroundColor,
      color: theme.heroTextColor
    }
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "trade-in-details__content"
  }, /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "trade-in-details__header-text"
  }, TradeInDetails_content.yourTradeInDetailsTitle), /*#__PURE__*/external_react_default.a.createElement(BreakdownTable, {
    hasLien: hasLien,
    lienAmount: lienAmount,
    lienItemLabel: TradeInDetails_content.loanBalanceLabel,
    positiveText: TradeInDetails_content.appliedToDownPaymentLabel,
    value: value
  }), totalSavings > 0 && /*#__PURE__*/external_react_default.a.createElement(components_WSYSCallOut, {
    theme: theme,
    savings: currency(totalSavings),
    incentiveAmount: incentiveAmount,
    salesTaxSavingsAmount: salesTaxSavingsAmount
  }))), /*#__PURE__*/external_react_default.a.createElement("div", {
    className: "trade-in-details__content"
  }, hasIncentive && /*#__PURE__*/external_react_default.a.createElement(InfoCard_InfoCard, {
    name: "trade-in",
    savingsTagText: TradeInDetails_content.tradeInSavingsTag,
    theme: theme,
    title: TradeInDetails_content.applyIncentiveHeader(incentiveAmountValue),
    description: TradeInDetails_content.incentiveDescription,
    lineItems: incentiveLineItems
  }), hasTaxSavings && /*#__PURE__*/external_react_default.a.createElement(InfoCard_InfoCard, {
    name: "sales-tax",
    savingsTagText: TradeInDetails_content.saveMoreTag,
    theme: theme,
    title: TradeInDetails_content.saveInSalesTaxHeader(salesTaxSavingsAmountValue, taxState),
    description: TradeInDetails_content.tradeInTaxSavingsDescription,
    lineItems: salesTaxLineItems
  }), hasNegativeEquity ? /*#__PURE__*/external_react_default.a.createElement(InfoCard_InfoCard, {
    name: "flex",
    theme: theme,
    title: TradeInDetails_content.flexibilityToPayOffHeader,
    description: payoffText,
    lineItems: negativeEquityLineItems
  }) : /*#__PURE__*/external_react_default.a.createElement(InfoCard_InfoCard, {
    name: "apply",
    theme: theme,
    title: TradeInDetails_content.applyDefaultCardTitle(currency(applyToDownPaymentAmount)),
    description: TradeInDetails_content.applyDefaultCardDescription,
    lineItems: defaultCardLineItems
  })));
};
/* harmony default export */ var src_TradeInDetails = (TradeInDetails);
// CONCATENATED MODULE: ./src/index.ts

/* harmony default export */ var src = __webpack_exports__["default"] = (src_TradeInDetails);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.ts");


/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map